import React from "react";
import { Link } from "react-router-dom";
import clausePage from "./ClausePage.module.css";
//icons
import ListIcon from "@material-ui/icons/List";
import DomainDisabled from "@material-ui/icons/DomainDisabled";
// end icons

const Clause2 = () => {
  return (
    <>
      <div
        className="divflex"
        style={{ fontSize: "24px", textTransform: "uppercase" }}
      >
        Changing Management
      </div>
      <main className={`${clausePage.container} ${clausePage.main}`}>
        <div>
          <Link to="/masterProcedureList?category=clause-2" className="panel">
            <ListIcon style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            Master <span className="card-btn-span">Procedure</span>
          </p>
        </div>
        <div>
          <Link to="/initialSupplyList" className="panel">
            <DomainDisabled style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            Initial Supply <span className="card-btn-span">Monitoring</span>
          </p>
        </div>
      </main>
    </>
  );
};

export default Clause2;
